import { Box, styled } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({}));
